import { NavigationGuardNext, Route } from 'vue-router';
import { NamedLocation } from '../types';
import { isAnalyticsEnabled } from '@/ui/helpers/featureHelper';

export function guardAnalyticsFeatureToggle(
  to: Route,
  from: Route,
  next: NavigationGuardNext,
): void {
  if (!isAnalyticsEnabled()) {
    const redirectTo: NamedLocation = { name: 'home' };
    next(redirectTo);
  }
  next();
}
